import React, { useState, KeyboardEvent } from 'react'
import './MessageInput.css'

const MAX_INPUT_LENGTH = 100

interface MessageInputProps {
  onSendMessage: (message: string) => void
  disabled?: boolean
}

export default function MessageInput({ onSendMessage, disabled }: MessageInputProps) {
  const [input, setInput] = useState('')

  const handleInputChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    const value = e.target.value
    // Limit to 100 characters
    if (value.length <= MAX_INPUT_LENGTH) {
      setInput(value)
    }
  }

  const handleSend = () => {
    if (input.trim() && !disabled && input.length <= MAX_INPUT_LENGTH) {
      // Truncate to 100 characters if somehow over limit
      const message = input.trim().substring(0, MAX_INPUT_LENGTH)
      onSendMessage(message)
      setInput('')
    }
  }

  const handleKeyPress = (e: KeyboardEvent<HTMLTextAreaElement>) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault()
      handleSend()
    }
  }

  const remainingChars = MAX_INPUT_LENGTH - input.length
  const isAtLimit = input.length >= MAX_INPUT_LENGTH

  return (
    <div className="message-input-container">
      <div className="message-input-wrapper">
        <textarea
          value={input}
          onChange={handleInputChange}
          onKeyPress={handleKeyPress}
          placeholder={disabled ? 'Connecting...' : 'Type your message...'}
          disabled={disabled}
          rows={1}
          className="message-input"
          maxLength={MAX_INPUT_LENGTH}
        />
        <button
          onClick={handleSend}
          disabled={disabled || !input.trim()}
          className="send-button"
        >
          <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M.5 1.163L1.619.522l13.5 7.5-13.5 7.5L.5 14.837V1.163z"
              fill="currentColor"
            />
          </svg>
        </button>
      </div>
      <div className="message-input-footer">
        <span className={`char-counter ${isAtLimit ? 'char-counter-limit' : ''}`}>
          {remainingChars} / {MAX_INPUT_LENGTH}
        </span>
      </div>
    </div>
  )
}

